module.exports = __webpack_public_path__ + "static/media/nbcc.30bdfe23.png";